import Home from '@/views/Home.vue';
import Comic from '@/views/Comic.vue';
import Latest from '@/views/Latest.vue';
import Archive from '@/views/Archive.vue';
import About from '@/views/About.vue';
import Auth from '@/views/Auth.vue';
import Login from '@/views/Login.vue';
import Characters from '@/views/Characters.vue';
import BuySeason from '@/views/BuySeason.vue';
import NotFound from '@/views/NotFound.vue';

export default [
  {
    name: 'Login',
    path: '/login',
    component: Login,
    props: true,
  },
  {
    name: 'Auth',
    path: '/auth',
    component: Auth,
  },
  {
    name: 'About',
    path: '/about',
    component: About,
  },
  {
    name: 'Characters',
    path: '/characters',
    component: Characters,
  },
  {
    name: 'Archive',
    path: '/archive',
    component: Archive,
  },
  {
    name: 'Buy',
    path: '/buy',
    redirect: {
      name: 'BuySeason',
      params: {
        seasonId: 1,
      },
    },
  },
  {
    name: 'BuySeason',
    path: '/season/:seasonId',
    component: BuySeason,
  },
  {
    name: 'Comic',
    path: '/strip/:stripNumber',
    component: Comic,
  },
  {
    name: 'First',
    path: '/first',
    redirect: {
      name: 'Comic',
      params: {
        stripNumber: 1,
      },
    },
  },
  {
    name: 'Latest',
    path: '/latest',
    component: Latest,
  },
  {
    name: 'Home',
    path: '',
    component: Home,
  },
  {
    path: '*',
    component: NotFound,
  },
];
